import React from 'react';

export interface StyleProps {
  textColor?: string;
  alignment?: string;
  fontSize?: string;
  lineHeight?: string;
  [key: string]: any;
}
export interface SubTitleProps {
  text?: string;
  styleProps?: StyleProps;
  className?: string;
}

const SubTitle: React.FC<SubTitleProps> = ({
  text,
  styleProps = {},
  className = '',
}) => {
  if (!text) return null;
  // Only set color inline if not provided via Tailwind className
  const style: React.CSSProperties = {
    ...Object.fromEntries(
      Object.entries(styleProps).filter(([key]) => key !== 'alignment'),
    ),
  };
  if (styleProps?.textColor && !/\btext-\w+/.test(className)) {
    style.color = styleProps.textColor;
  }
  return (
    <p className={className} style={style}>
      {text}
    </p>
  );
};

export default SubTitle;
